/* eslint-disable @typescript-eslint/ban-types */
import { TFailArgs } from './types'
import { TaggedFail } from './Fail'
import { parseArgs } from './parseArgs'

export type TAbortDetails = { signal?: AbortSignal }

export class AbortFail extends TaggedFail('Abort')<TAbortDetails> {
  static fromC(...args: TFailArgs<TAbortDetails, 'signal'>) {
    return (signal: AbortSignal | undefined): AbortFail => {
      const opts = Object.assign(
        parseArgs<Omit<TAbortDetails, 'signal'>>(args),
        { signal },
      )
      opts.message ??= 'Aborted.'
      return new AbortFail(opts)
    }
  }

  static from(
    signal: AbortSignal | undefined,
    ...args: TFailArgs<TAbortDetails, 'signal'>
  ): AbortFail {
    return AbortFail.fromC(...args)(signal)
  }
}
